import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { useState } from "react";
import { Share2, Mail, MessageCircle, Twitter, Link as LinkIcon, Check } from "lucide-react";
import { Button } from "../components/ui/button";

export default function SharePage() {
  const [copied, setCopied] = useState(false);
  const currentUrl = window.location.origin;
  const copy = () => {
    navigator.clipboard.writeText(currentUrl);
    setCopied(true); setTimeout(() => setCopied(false), 1500);
  };

  const targets = [
    { i: Mail, label: "Email", href: `mailto:?subject=OmniSearch&body=Découvre ce moteur de recherche : ${currentUrl}` },
    { i: MessageCircle, label: "WhatsApp", href: `https://wa.me/?text=${encodeURIComponent("Découvre OmniSearch : " + currentUrl)}` },
    { i: Twitter, label: "X / Twitter", href: `https://twitter.com/intent/tweet?text=${encodeURIComponent("OmniSearch — un moteur sans tracker ")}&url=${encodeURIComponent(currentUrl)}` },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 sm:px-6 py-12" data-testid="share-page">
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight flex items-center gap-3 mb-2">
          <Share2 size={28} /> Partager
        </h1>
        <p className="text-sm text-gray-500 mb-8">Faites découvrir OmniSearch à vos contacts.</p>

        <div className="border border-[var(--omni-border)] rounded-lg p-4 flex items-center gap-3 mb-8">
          <LinkIcon size={16} className="text-gray-400" />
          <code className="flex-1 text-sm truncate">{currentUrl}</code>
          <Button onClick={copy} size="sm" className="bg-black hover:bg-gray-800 text-white rounded-full" data-testid="share-copy-btn">
            {copied ? <><Check size={14} className="mr-1 text-emerald-300" /> Copié</> : "Copier"}
          </Button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {targets.map(({ i: Icon, label, href }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="border border-[var(--omni-border)] rounded-lg p-5 hover:border-black transition text-center" data-testid={`share-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <Icon className="mx-auto mb-2 text-[var(--omni-accent)]" size={22} />
              <div className="font-medium">{label}</div>
            </a>
          ))}
        </div>

        <p className="text-xs text-gray-400 mt-12">
          💡 Astuce : pressez le menu trois points → Partager n'importe où sur le site pour lancer le partage natif.
        </p>
      </main>
      <Footer />
    </div>
  );
}
